// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemQuantityColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import translateX from 'utils/translateX';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the quantity column for item subtables.
// options.size: 'small' (11px, default) | 'middle' (14px)
function itemQuantityColumn(options = {}) {
  const { size } = options;
  const fontSize = resolveItemFontSize(size, 11);

  return {
    title: translateX('qty'),
    dataIndex: 'quantity',
    width: 80,
    align: 'right',
    sorter: (a, b) => (a?.quantity || 0) - (b?.quantity || 0),
    render: (_, item) => <Text style={{ fontSize }}>{item?.quantity ?? '—'}</Text>,
  };
}

export default itemQuantityColumn;
